<script>
import Panel from '@phoenix/mixins/components/common/Panel';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [Panel],

  computed: {
    _headerClasses() {
      return ['panel__header', 'h4', { 'panel__header--bordered': this.headerBordered }, ...this.headerClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="panel__overlay" :data-panel-close="id"></div>

    <div class="panel__body">
      <header :class="_headerClasses">
        <div v-if="title">{{ title }}</div>

        <slot name="header"></slot>

        <button
          type="button"
          class="btn btn--default btn--icon-only btn--icon ms-auto btn--sm btn--negative-on-dark btn--rounded panel__close"
          :data-panel-close="id"
          aria-expanded="false"
          data-cy="panel-close"
        >
          <span class="sr-only">{{ $t('Accessibility.modal.close') }}</span>
          <span class="btn__icon pointer-events-none">
            <phx-icon icon="cross-16" />
          </span>
        </button>
      </header>

      <div :class="_contentClasses">
        <slot name="content"></slot>
      </div>

      <footer v-if="hasFooterSlot" class="panel__footer">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>
